/* globals zoomSdk */
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Authorization } from './components/Authorization'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'

let once = 0 // to prevent increasing number of event listeners being added

function App() {
  const navigate = useNavigate()
  const location = useLocation()
  const [error, setError] = useState(null)
  const [user, setUser] = useState(null)
  const [runningContext, setRunningContext] = useState(null)
  const [counter, setCounter] = useState(0)
  const [userContextStatus, setUserContextStatus] = useState('')

  useEffect(() => {
    async function configureSdk() {
      // to account for the 2 hour timeout for config
      const configTimer = setTimeout(() => {
        setCounter(counter + 1)
      }, 120 * 60 * 1000)

      try {
        // Configure the JS SDK - MINIMAL CONFIG for DataOffset OAuth only
        // Only include APIs that are essential for authentication
        const configResponse = await zoomSdk.config({
          capabilities: [
            // Essential OAuth capabilities only
            'authorize',
            'onAuthorized',
            'promptAuthorize',
            'getUserContext',
            
            // Basic app functionality
            'getRunningContext',
            'openUrl'
          ],
          version: '0.16.0'
        })
        console.log('App configured', configResponse)
        // The config method returns the running context of the Zoom App
        setRunningContext(configResponse.runningContext)
        setUserContextStatus(configResponse.auth.status)
      } catch (error) {
        console.log(error)
        setError('There was an error configuring the JS SDK')
      }
      return () => {
        clearTimeout(configTimer)
      }
    }
    configureSdk()
  }, [counter])

  return (
    <div className='App'>
      {error && (
        <div style={{ color: 'red', marginTop: '20px' }}>
          <p>Error: {error}</p>
        </div>
      )}

      <Authorization
        handleError={setError}
        handleUserContextStatus={setUserContextStatus}
        handleUser={setUser}
        sdkConfigured={!!runningContext}
        user={user}
        userContextStatus={userContextStatus}
      />
    </div>
  )
}

export default App
